import styles from './delete-category-dialog.module.scss';
import { useContext, useState } from 'react';
import { makeCourseRequest, useCourseGetRequestHook } from '../../../../requestUtils';
import { Dialog, DialogActions, DialogContent, DialogTitle, GrayOutlinedButton, LoadingButton, SnackBarContext, Typography } from '@frontend-workspace/react-shared-lib';
import { ICategory } from '../../../../_models/category';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface DeleteCategoryDialogProps {
  onClose: () => void,
  open: boolean,
  categoryId: string,
  refreshData: () => void
}

export function DeleteCategoryDialog(props: DeleteCategoryDialogProps) {
  const { data: category }: { data: ICategory } = useCourseGetRequestHook(`resource/category/${props.categoryId}`, undefined);

  const { t } = useTranslation();
  const { setSnackbarMessage } = useContext(SnackBarContext);
  const [loading, setLoading] = useState<boolean>(false);

  const handleDeleteCategory = () => {
    setLoading(true);
    makeCourseRequest(`resource/category/delete/${props.categoryId}`, 'DELETE').then(result => {
      setSnackbarMessage({ content: t('deleteCategory.deletedCategoryFromList'), type: "success" });
      setLoading(false);
      props.refreshData();
      props.onClose();
    }).catch(() => setSnackbarMessage({ content: t('deleteCategory.couldNotDeleteCategoryFromList'), type: "error" }));
  };

  return (
    <Dialog
      open={props.open}
      maxWidth="sm"
      fullWidth>
      <DialogTitle className='mb-4'>
        {t('deleteCategory.areYouSureYouWantToDeleteCategory')}
      </DialogTitle>
      <DialogContent>
        <Typography
          component="div"
          variant='subtitle3'
          className='mb-3'>
          {category?.name}
        </Typography>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          variant="contained"
          size='large'
          color='error'
          onClick={handleDeleteCategory}
          disabled={loading}
          loading={loading}
          className='minButtonWidth'>
          {loading ? '' : t('standard.delete')}
        </LoadingButton>
        <GrayOutlinedButton
          variant="outlined"
          size='large'
          onClick={props.onClose}
          className='minButtonWidth'>
          {t('standard.cancel')}
        </GrayOutlinedButton>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteCategoryDialog;
